// The one segmented switcher for view/filter choices inside a page: a pill rail, the chosen
// option raised on white. Options: [{ key, label, count }]. Counts render inline when given.
export default function Segmented({ options, value, onChange, testIdPrefix, className = "", children }) {
  return (
    <div className={`inline-flex max-w-full flex-wrap items-center gap-1 rounded-2xl bg-slate-100 p-1 ${className}`}
         data-testid={testIdPrefix ? `${testIdPrefix}-rail` : undefined}>
      {options.map((o) => {
        const Icon = o.icon;
        const on = value === o.key;
        return (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange(o.key)}
            data-testid={o.testId || (testIdPrefix ? `${testIdPrefix}-${o.key}` : undefined)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3 py-1 text-xs font-medium transition-colors ${
              on ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-800"
            }`}
          >
            {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
            {o.label}
            {o.count !== undefined && o.count !== null && (
              <span className="tabular-nums text-slate-500">{o.count}</span>
            )}
          </button>
        );
      })}
      {children}
    </div>
  );
}
